var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-container",
      class: [
        "cw-container-colspan-" + _vm.colSpan,
        _vm.showEditMode && _vm.canEdit ? "cw-container-active" : "",
        _vm.containerClass,
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-container-content",
        },
        [
          _vm.showEditMode
            ? _c(
                "header",
                {
                  staticClass: "cw-container-header",
                  class: {
                    "cw-container-header-open": _vm.isOpen,
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "cw-container-header-toggle",
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.isOpen,
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          _vm.isOpen = !_vm.isOpen
                        },
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: _vm.isOpen ? "arr_1down" : "arr_1right",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.container.attributes.title) +
                            " (" +
                            _vm._s(_vm.container.attributes.width) +
                            ")"
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.blockedByAnotherUser
                        ? _c("studip-icon", {
                            attrs: {
                              shape: "lock-locked",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.blockedByAnotherUser
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "cw-default-container-blocker-warning",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Wird im Moment von %{ userName } bearbeitet"
                                      ),
                                      {
                                        userName: this.blockingUserName,
                                      }
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("courseware-container-actions", {
                    attrs: {
                      canEdit: _vm.canEdit,
                      container: _vm.container,
                    },
                    on: {
                      editContainer: _vm.displayEditDialog,
                      changeContainer: _vm.displayChangeDialog,
                      deleteContainer: _vm.displayDeleteDialog,
                      removeLock: _vm.displayRemoveLockDialog,
                      copyToClipboard: _vm.copyToClipboard,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen",
                },
              ],
              staticClass: "cw-block-wrapper",
              class: {
                "cw-block-wrapper-active": _vm.showEditMode,
              },
            },
            [_vm._t("containerContent")],
            2
          ),
          _vm._v(" "),
          _vm.showEditDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textEditTitle,
                  confirmText: _vm.textEditConfirm,
                  confirmClass: "accept",
                  closeText: _vm.textEditClose,
                  closeClass: "cancel",
                  confirmDisabled: !_vm.editDataValid,
                  height: "430",
                  width: "680",
                },
                on: {
                  close: _vm.closeEdit,
                  confirm: _vm.storeContainer,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "dialogContent",
                      fn: function fn() {
                        return [_vm._t("containerEditDialog")]
                      },
                      proxy: true,
                    },
                    {
                      key: "dialogButtons",
                      fn: function fn() {
                        return [_vm._t("containerEditButtons")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showChangeDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.$gettext("Abschnitt verändern"),
                  confirmText: _vm.$gettext("Speichern"),
                  confirmClass: "accept",
                  closeText: _vm.$gettext("Abbrechen"),
                  closeClass: "cancel",
                  height: "520",
                  width: "480",
                },
                on: {
                  close: _vm.closeChange,
                  confirm: _vm.storeChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "dialogContent",
                      fn: function fn() {
                        return [
                          _c(
                            "form",
                            {
                              staticClass: "default",
                              on: {
                                submit: function submit($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-radioset-wrapper",
                                  attrs: {
                                    role: "group",
                                    "aria-labelledby": "container-type",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      attrs: {
                                        id: "container-type",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Typ")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cw-radioset",
                                    },
                                    _vm._l(
                                      _vm.containerTypes,
                                      function (container, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "cw-radioset-box",
                                            class: [
                                              container.type === _vm.changeType
                                                ? "selected"
                                                : "",
                                            ],
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.changeType,
                                                  expression: "changeType",
                                                },
                                              ],
                                              attrs: {
                                                type: "radio",
                                                id: "type-" + container.type,
                                                name: "container-type",
                                              },
                                              domProps: {
                                                value: container.type,
                                                checked: _vm._q(
                                                  _vm.changeType,
                                                  container.type
                                                ),
                                              },
                                              on: {
                                                change: function change(
                                                  $event
                                                ) {
                                                  _vm.changeType =
                                                    container.type
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "type-" + container.type,
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "label-icon",
                                                  class: [
                                                    container.type,
                                                    container.type ===
                                                    _vm.changeType
                                                      ? "selected"
                                                      : "",
                                                  ],
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(container.title)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cw-radioset-wrapper",
                                  attrs: {
                                    role: "group",
                                    "aria-labelledby": "container-style",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      attrs: {
                                        id: "container-style",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$gettext("Stil")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cw-radioset",
                                    },
                                    _vm._l(
                                      _vm.containerStyles,
                                      function (style, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "cw-radioset-box",
                                            class: [
                                              style.colspan === _vm.changeStyle
                                                ? "selected"
                                                : "",
                                            ],
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.changeStyle,
                                                  expression: "changeStyle",
                                                },
                                              ],
                                              attrs: {
                                                type: "radio",
                                                id:
                                                  "change-style-" +
                                                  style.colspan,
                                                name: "change-container-style",
                                              },
                                              domProps: {
                                                value: style.colspan,
                                                checked: _vm._q(
                                                  _vm.changeStyle,
                                                  style.colspan
                                                ),
                                              },
                                              on: {
                                                change: function change(
                                                  $event
                                                ) {
                                                  _vm.changeStyle =
                                                    style.colspan
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for:
                                                    "change-style-" +
                                                    style.colspan,
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "label-icon",
                                                  class: [
                                                    style.colspan,
                                                    style.colspan ===
                                                    _vm.changeStyle
                                                      ? "selected"
                                                      : "",
                                                  ],
                                                }),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(_vm._s(style.title)),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  532078767
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showDeleteDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textDeleteTitle,
                  question: _vm.textDeleteAlert,
                  height: "180",
                  width: "380",
                },
                on: {
                  confirm: _vm.executeDelete,
                  close: _vm.closeDeleteDialog,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showRemoveLockDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textRemoveLockTitle,
                  question: _vm.textRemoveLockAlert,
                  height: "200",
                  width: "450",
                },
                on: {
                  confirm: _vm.executeRemoveLock,
                  close: function close($event) {
                    _vm.showRemoveLockDialog = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }